import * as types from '@/store/mutations'
import api from '@/services/notifications.js'
//import moment from 'moment'

const getters = {
    notifications: (state)=> state.notifications,
}

const actions = {
  /*
   * Fetches all notifications
   * */
  loadAllNotifications({ commit }) {
    return new Promise((resolve, reject) => {
      api.getAllNotifications().then((res)=>{
        commit(types.SET_ALL_NOTIFICATIONS,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  
  markNotificationsRead(context, id) {
    //console.log("Setting notification as read", id)
    return new Promise((resolve, reject) => {
      api.setNotificationsRead(id).then((res)=>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  }        
  
}

const mutations = {
  [types.SET_ALL_NOTIFICATIONS](state, notifications) {
    state.notifications = notifications
  }
}

const state = {
  notifications: []
}

export default {
  state,
  getters,
  actions,
  mutations
}
